(() => {
  const storageKey = 'bizafrikaCataloguePreviewRfq';
  const clean = (value, limit = 160) => typeof value === 'string' ? value.replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, limit) : '';
  const quantity = value => /^\d{1,4}$/.test(String(value)) && Number(value) > 0 ? Number(value) : null;
  const normalise = values => {
    if (!Array.isArray(values)) return [];
    const seen = new Set();
    return values.slice(0, 100).flatMap(item => {
      if (!item || typeof item !== 'object') return [];
      const key = clean(item.key), name = clean(item.name);
      if (!key || !name || seen.has(key)) return [];
      seen.add(key);
      return [{ key, name, kind: clean(item.kind), ref: clean(item.ref), quantity: quantity(item.quantity) }];
    });
  };
  const summary = items => [
    'BizAfrika product RFQ', '',
    ...normalise(items).map((item, index) => `${index + 1}. ${item.kind} — ${item.name}${item.ref ? ` (${item.ref})` : ''}\n   Quantity: ${item.quantity ?? 'not yet known'}${item.kind === 'Dragflow pump family' ? '\n   Family shortlist — specification help needed; no model selected.' : ''}`),
    '', 'Please confirm technical suitability, pricing, availability and lead time for the items above.',
  ].join('\n');
  const read = () => {
    try {
      if (window.sessionStorage.getItem(`${storageKey}Fallback`) === '1') {
        const raw = window.sessionStorage.getItem(storageKey);
        if (raw !== null) return normalise(JSON.parse(raw));
      }
    } catch (_) { /* Normal storage read can still succeed. */ }
    for (const type of ['localStorage', 'sessionStorage']) {
      try {
        const raw = window[type].getItem(storageKey);
        if (raw !== null) return normalise(JSON.parse(raw));
      } catch (_) { /* Fall back to the other store, without clearing either. */ }
    }
    return [];
  };
  const save = items => {
    let saved = false;
    for (const type of ['localStorage', 'sessionStorage']) {
      try {
        window[type].setItem(storageKey, JSON.stringify(normalise(items)));
        if (type === 'sessionStorage') window.sessionStorage.setItem(`${storageKey}Fallback`, saved ? '0' : '1');
        saved = true;
      } catch (_) { /* Keep the in-memory list usable. */ }
    }
    return saved;
  };
  const brands = ['Dragflow', 'Eaton', 'Emerson', 'Festo', 'Grundfos', 'KROHNE', 'Amandla Pumps', 'Goodwin Pumps', 'Tsurumi Pumps', 'Xylem'];
  const categories = ['Pumps and dredging', 'Electrical and power', 'Automation and pneumatics', 'Flow and measurement', 'Electric pumps', 'Hydraulic pumps', 'Automation & Drives', 'Circuit Protection', 'Circuit Protection — MCB', 'Circuit Protection — MCCB', 'Conveyor Safety & Controls', 'IEC Control & Automation', 'Legacy product support', 'Motor Control & Contactors', 'Industrial electrical products', 'NEMA Control & Switching', 'Operator Controls & Signalling', 'Power Quality & UPS', 'Sensors & Industrial Switching', 'Sourced electrical products'];
  const statuses = ['Quotation available', 'Specification confirmed on quotation', 'Availability confirmed on quotation', 'Specification guidance available', 'Alternative or replacement guidance'];
  const context = params => ({
    intent: params.get('intent') === 'guidance' ? 'guidance' : '',
    source: ['home', 'products', 'shop', 'brand'].includes(params.get('source')) ? params.get('source') : '',
    brand: params.get('brand') === 'Tsurumi' ? 'Tsurumi Pumps' : (brands.includes(params.get('brand')) ? params.get('brand') : ''),
    category: categories.includes(params.get('category')) ? params.get('category') : '',
    status: statuses.includes(params.get('status')) ? params.get('status') : '',
    query: clean(params.get('search'), 100),
  });
  const guidanceUrl = values => {
    const url = new URL('/pages/contact-biz-afrika', window.location.origin);
    url.searchParams.set('intent', 'guidance');
    const allowed = context(new URLSearchParams({ ...values, intent: 'guidance' }));
    for (const [key, value] of Object.entries(allowed)) if (value && key !== 'intent') url.searchParams.set(key === 'query' ? 'search' : key, value);
    return `${url.pathname}${url.search}`;
  };
  const guidanceSummary = value => [
    'Product guidance request',
    value.source && `Website route: ${value.source}`,
    value.brand && `Brand: ${value.brand}`,
    value.category && `Category: ${value.category}`,
    value.status && `Reference filter: ${value.status}`,
    value.query && `Search: ${value.query}`,
    '', 'Application / requirement: ',
  ].filter(line => line !== false).join('\n');
  window.BizAfrikaBuyerJourney = { quantity, normalise, summary, read, save, context, guidanceUrl, guidanceSummary };
})();
